import { ref as f, onMounted as y, onUnmounted as _, openBlock as v, createElementBlock as m, renderSlot as g } from "vue";
const h = (t, n) => {
  const e = t.__vccOpts || t;
  for (const [r, s] of n)
    e[r] = s;
  return e;
}, k = {
  props: {
    options: {
      type: Object
    }
  },
  setup(t, { emit: n }) {
    let e = null;
    const r = f(null), s = [
      "select",
      "change",
      "settle",
      "scroll",
      "dragStart",
      "dragMove",
      "dragEnd",
      "pointerDown",
      "pointerMove",
      "pointerUp",
      "staticClick",
      "lazyLoad",
      "bgLazyLoad",
      "fullscreenChange"
    ];
    return y(async () => {
      const i = (await import("./index-e1678e9e.js").then((o) => o.i)).default, a = {
        imagesLoaded: !0,
        removeAriaHidden: !0,
        ...t.options
      };
      e = new i(r.value, {
        ...a,
        on: {
          ready: function() {
            if (a.removeAriaHidden)
              for (const o of this.element.querySelectorAll('[aria-hidden="true"]'))
                o.removeAttribute("aria-hidden");
            n("ready", this);
          }
        }
      });
      for (const o of s)
        e.on(o, (c, l, d, u, p) => {
          n(o, c, l, d, u, p);
        });
      try {
        e.on("dragStart", () => e.slider.style.pointerEvents = "none"), e.on("dragEnd", () => e.slider.style.pointerEvents = "auto");
      } catch {
      }
    }), _(() => {
      e && e.destroy();
    }), {
      carousel: r
    };
  }
}, E = { ref: "carousel" };
function $(t, n, e, r, s, i) {
  return v(), m("div", E, [
    g(t.$slots, "default")
  ], 512);
}
const x = /* @__PURE__ */ h(k, [["render", $]]), F = {
  install: (t) => {
    t.component("Flickity", x);
  }
};
export {
  F as default
};
